import { useMutation } from "react-query";

import type { AppointmentV2, PutAppointmentV2ManagerArgs } from "api/services/appointment/schemas/appointment_v2";
import { useApiClient } from "api/useApiClient";

export const usePutAppointmentV2Manager = () => {
  const client = useApiClient();

  return useMutation<AppointmentV2, Error, PutAppointmentV2ManagerArgs>({
    mutationFn: args => client.putAppointmentV2Manager(args),
  });
};
